import { actionCreator } from '@ardoq/rxbeach';
import { ArdoqId } from '@ardoq/api-types';

export const updateSelectedReferences = actionCreator<{
  referenceIds: ArdoqId[];
}>('[contextMenus] UPDATE_SELECTED_REFERENCES');
